import { render, staticRenderFns } from "./SpecRequestsPanel.vue?vue&type=template&id=465684da&scoped=true&lang=pug&"
import script from "./SpecRequestsPanel.vue?vue&type=script&lang=js&"
export * from "./SpecRequestsPanel.vue?vue&type=script&lang=js&"
import style0 from "./SpecRequestsPanel.vue?vue&type=style&index=0&id=465684da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465684da",
  null
  
)

export default component.exports